import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    RadioGroup,
    Radio,
    FormControlLabel,
    Button,
    CircularProgress,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import { useParams } from "react-router-dom";
import { getAPI, postAPI } from "../network";

const SubmitSurveyPage = () => {
    const { token } = useParams();
    const companyId = token.split("-")[0];
    const fsrId = token.split("-")[1];
    const userId = token.split("-")[2];

    const [questionnaire, setQuestionnaire] = useState(null);
    const [answers, setAnswers] = useState({});
    const [notes, setNotes] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);

    useEffect(() => {
        const fetchQuestionnaire = async () => {
            const data = await getAPI(`/building/questionnaire/company/${companyId}`);
            if (data) {
                setQuestionnaire(data);
                const initial = {};
                data.questions.forEach((q) => {
                    initial[q.order] = null;
                });
                setAnswers(initial);
            }
            setLoading(false);
        };
        fetchQuestionnaire();
    }, [companyId]);

    useEffect(() => {
        if (showThankYou) {
            const timer = setTimeout(() => {
                window.close();
            }, 10000); // 10 seconds
            return () => clearTimeout(timer);
        }
    }, [showThankYou]);

    const handleScoreChange = (order, score) => {
        setAnswers((prev) => ({ ...prev, [order]: parseInt(score) }));
    };

    const handleSubmit = async () => {
        const payload = {
            questionnaireId: questionnaire._id,
            userId,
            answers: Object.entries(answers).map(([questionOrder, score]) => ({
                questionOrder: parseInt(questionOrder),
                score: parseInt(score)
            })),
            notes,
            fsrId
        };

        setSubmitting(true);
        const response = await postAPI("/building/answers", payload);
        setSubmitting(false);

        if (response) {
            setShowThankYou(true);
        }
    };

    if (loading) {
        return <Box p={4}><CircularProgress /></Box>;
    }

    if (!questionnaire) {
        return <Box p={4}><Typography>Questionnaire not found.</Typography></Box>;
    }

    return (
        <Box p={4} maxWidth="800px" margin="auto">
            <Typography variant="h4" mb={4} align="center">{questionnaire.title}</Typography>

            <Paper sx={{ p: 3 }}>
                {questionnaire.questions.map((q) => (
                    <Paper key={q.order} elevation={2} sx={{ p: 2, mb: 3, backgroundColor: "#f9f9f9" }}>
                        <Typography variant="h6" mb={2}>Q{q.order}: {q.text}</Typography>
                        <Box display="flex" gap={2} flexWrap="wrap">
                            {[...Array(10)].map((_, i) => (
                                <Box key={i + 1} textAlign="center">
                                    <Radio
                                        checked={answers[q.order] === i + 1}
                                        onChange={(e) => handleScoreChange(q.order, e.target.value)}
                                        value={(i + 1).toString()}
                                        name={`radio-group-${q.order}`}
                                        sx={{ display: 'block', mb: 0.5 }}
                                    />
                                    <Typography variant="caption">{i + 1}</Typography>
                                </Box>
                            ))}
                        </Box>

                    </Paper>
                ))}

                <TextField
                    label="Additional Notes (optional)"
                    multiline
                    fullWidth
                    rows={4}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    sx={{ mb: 3 }}
                />

                <Box textAlign="center">
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleSubmit}
                        disabled={submitting}
                    >
                        {submitting ? "Submitting..." : "Submit Response"}
                    </Button>
                </Box>
            </Paper>

            {/* Thank You Modal */}
            <Dialog open={showThankYou}>
                <DialogTitle>Thank You!</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Your response has been recorded. This tab will close automatically in 10 seconds.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => window.close()} color="primary" autoFocus>
                        Close Now
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
       
    );
};

export default SubmitSurveyPage;

